import bootstrap from 'bootstrap/dist/css/bootstrap.min.css';

export default bootstrap;
